import { getStaticUrl } from "js/config";
import log from "js/core/logger";

const audioContext = new (window.AudioContext || window.webkitAudioContext)();

function getAudioBufferFromUrl(url) {
    return fetch(url)
        .then(response => response.arrayBuffer())
        .then(arrayBuffer => new Promise((resolve, reject) => {
            audioContext.decodeAudioData(arrayBuffer, resolve, reject);
        }));
}

let emptyAudioBuffer;
async function prepareToUnlockAudio() {
    if (emptyAudioBuffer) {
        return;
    }

    emptyAudioBuffer = await getAudioBufferFromUrl(getStaticUrl("/images/nothing.wav"));
}

let isAudioUnlocked = false;
function unlockAudio() {
    if (!emptyAudioBuffer) {
        throw new Error("Empty audio buffer has't been loaded, call prepareToUnlockAudio() first");
    }

    if (isAudioUnlocked) {
        return;
    }

    const audio = audioContext.createBufferSource();
    audio.buffer = emptyAudioBuffer;
    audio.connect(audioContext.destination);
    audio.start(0);
    audio.onended = () => isAudioUnlocked = true;
    audio.onerror = err => log.error(err);
}

export { audioContext, getAudioBufferFromUrl, prepareToUnlockAudio, unlockAudio };
